import React, { useContext } from 'react'
import CartProduct from './CartProduct'
import '../css/cartproductslist.css'

const CartProductsList = ({ cart, openCustomPopup, closeModal, page }) => {

  return (
    <div className={"shopping__list"+" "+page}>
        {
          cart.map(item => <CartProduct key={item.mango_id} item={item} openCustomPopup={openCustomPopup} closeModal={closeModal} page={page} />)
        }
    </div>
  )
}

export default CartProductsList